import { useState } from 'react';
const DEFAULT_GRANT_DATA_TYPE = 'cellphoneNumber';

const useCustomHook = () => {
  const [isOpenConfirmDialog, setIsOpenconfirmDialog] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState(null);
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [size, setSize] = useState(10);
  const [branchData, setBranchData] = useState(null);
  const [cameFromGuilds, setCameFromGuilds] = useState(false);
  const [isImprest, setIsImprest] = useState(null);
  const [funderData, setFunderData] = useState(null);
  const [activeDetailID, setActiveDetailID] = useState(null);
  const [filterParams, setFilterParams] = useState(null);
  const [isOpenTagDialog, setIsOpenTagDialog] = useState(false);
  const [isOpenUploadDialog, setIsOpenUploadDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  const [isLoadingExport, setIsLoadingEport] = useState(false);
  const [isShowExport, setIsShowEport] = useState(false);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenShowExportDG, setIsOpenShowExportDG] = useState(false);
  const [isOpenTransactionReceipt, setIsOpenTransactionReceipt] = useState(false);
  const [dataTimeLine, setDataTimeLine] = useState(null);
  const [timeLineLength, setTimeLineLength] = useState(0);
  const [statistics, setStatistics] = useState({
    sumVariz: 0,
    sumBardasht: 0,
    amountChange: 0,
  });

  const [isSubmiting, setIsSubmiting] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [beforeUlpoadList, setBeforeUlpoadList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [rowsWithError, setRowsWithError] = useState([]);
  const [isResultErrorsOpen, setIsResultErrorsOpen] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  const [guildCode, setGuildCode] = useState(null);
  const [foundUser, setFoundUser] = useState(null);
  const [amount, setAmount] = useState(null);
  const [description, setDescription] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null); // user checked with contact services
  const [incomingUserQuery, setIncomingUserQuery] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [contactId, setContactId] = useState(null);
  const [captchaId, setCaptchaId] = useState(null);
  const [captchaImg, setCaptchaImg] = useState(null);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');

  return {
    loading, setLoading,
    filterParams, setFilterParams,
    size, setSize,
    isLoading, setIsLoading,
    file, setFile,
    rowsWithError, setRowsWithError,
    isResultErrorsOpen, setIsResultErrorsOpen,
    isBulk, setIsBulk,
    guildCode, setGuildCode,
    foundUser, setFoundUser,
    amount, setAmount,
    description, setDescription,
    currentUserId, setCurrentUserId,
    incomingUserQuery, setIncomingUserQuery,
    isConfirmModalOpen, setIsConfirmModalOpen,
    grantUserDataType, setGrantUserDataType,
    contactId, setContactId,
    captchaId, setCaptchaId,
    captchaLoading, setCaptchaLoading,
    enteredCaptcha, setEnteredCaptcha,
    captchaImg, setCaptchaImg,
    activeDetailID, setActiveDetailID,
    filterParams, setFilterParams,
    isOpenTagDialog, setIsOpenTagDialog,
    isOpenUploadDialog, setIsOpenUploadDialog,
    selectedRow, setSelectedRow,
    loadingPage, setLoadingPage,
    isLoadingExport, setIsLoadingEport,
    isShowExport, setIsShowEport,
    isOpenExportDG, setIsOpenExportDG,
    isOpenShowExportDG, setIsOpenShowExportDG,
    isOpenTransactionReceipt, setIsOpenTransactionReceipt,
    dataTimeLine, setDataTimeLine,
    timeLineLength, setTimeLineLength,
    statistics, setStatistics,
    branchData, setBranchData,
    cameFromGuilds, setCameFromGuilds,
    isImprest, setIsImprest,
    funderData, setFunderData,
    isOpenConfirmDialog,
    setIsOpenconfirmDialog,
    formData, setFormData,
    userName, setUserName,
    submitLoading,
    setSubmitLoading,
    data,
    setData,
    page, setPage,
    beforeUlpoadList, setBeforeUlpoadList,
    isSubmiting, setIsSubmiting,
    selectedTags, setSelectedTags,
  };
};

export default useCustomHook;
